import {
  TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES,
  TRESPONSE_ORDER_DETAILS_HEADER,
  TRESPONSE_ORDER_DETAILS_LEARNING_CURVE,
  TRESPONSE_ORDER_DETAILS_PLANNING_CARD,
  TRESPONSE_ORDER_DETAILS_VIEW_LEARNING_CURVE,
  TRESPONSE_ORDER_ALLOCATION_CARD_DATA,
  TRESPONSE_PO_DETAILS_CARD,
  TRESPONSE_PO_DETAILS_COLOR_SIZE,
  TRESPONSE_GET_PROCESS_MAP_BY_OTL_ID,
  TRESPONSE_ORDER_TIMELINE_CARD_DATA,
  TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA,
  TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA,
} from '@monorepo/types';

export type TOrderDetailsState = {
  isSyncEnabled: boolean;

  headerInfo: TRESPONSE_ORDER_DETAILS_HEADER | null;
  showHeaderDetailsLoader: boolean;

  poDetailsCardInfo: TRESPONSE_PO_DETAILS_CARD | null;
  showPoDetailsLoader: boolean;
  poColorSizeQtyInfo: TRESPONSE_PO_DETAILS_COLOR_SIZE | null;

  showProcessMappingDetailsLoader: boolean;
  processMappingDetailsCardInfo: TRESPONSE_GET_PROCESS_MAP_BY_OTL_ID | null;

  planningCardInfo: TRESPONSE_ORDER_DETAILS_PLANNING_CARD | null;
  showPlanningCardLoader: boolean;

  allocationCardInfo: TRESPONSE_ORDER_ALLOCATION_CARD_DATA | null;
  showOrderAllocationLoader: boolean;

  orderTimelineCardInfo: TRESPONSE_ORDER_TIMELINE_CARD_DATA | null;
  showOrderTimelineLoader: boolean;

  linewisePlannedQtyCardInfo: TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA | null;
  showLinewisePlannedQtyLoader: boolean;

  operationBreakdownDetailsInfo: TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA | null;
  showOperationBreakdownDetailsLoader: boolean;

  learningCurveCardInfo: TRESPONSE_ORDER_DETAILS_LEARNING_CURVE | null;
  showLearningCurveCardLoader: boolean;

  allLearningCurves: TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES | null;
  showAllLearningCurvesLoader: boolean;

  viewLearningCurve: TRESPONSE_ORDER_DETAILS_VIEW_LEARNING_CURVE | null;
};

export const TOrderDetailsActionType = {
  SetIsSyncEnabled: 'SET_IS_SYNC_ENABLED' as const,
  SetPlanningCardLoader: 'SET_PLANNING_LOADER' as const,
  ClearPlanningCardDetails: 'CLEAR_PLANNING_CARD_DETAILS' as const,
  GetPlanningCard: 'GET_PlANNING_CARD' as const,
  GetPlanningCardSuccess: 'GET_PLANNING_CARD_SUCCESS' as const,
  GetPlanningCardFailure: 'GET_PLANNING_CARD_FAILURE' as const,
  SetHeaderLoader: 'SET_HEADER_LOADER' as const,
  GetHeader: 'GET_HEADER' as const,
  GetHeaderSuccess: 'GET_HEADER_SUCCESS' as const,
  GetHeaderFailure: 'GET_HEADER_FAILURE' as const,
  EditHeader: 'EDIT_HEADER' as const,
  EditHeaderSuccess: 'EDIT_HEADER_SUCCESS' as const,
  EditHeaderFailure: 'EDIT_HEADER_FAILURE' as const,
  EditDefaultCount: 'EDIT_DEFAULT_COUNT' as const,
  EditDefaultCountSuccess: 'EDIT_DEFAULT_COUNT_SUCCESS' as const,
  EditDefaultCountFailure: 'EDIT_DEFAULT_COUNT_FAILURE' as const,
  SetLearningCurveCardLoader: 'SET_LEARNING_CURVE_CARD_LOADER' as const,
  ClearlearningCurveCardDetails: 'CLEAR_LEARNING_CURVE_CARD_DETAILS' as const,
  GetLearningCurveCard: 'GET_LEARNING_CURVE_CARD_CARD' as const,
  GetLearningCurveCardSuccess: 'GET_LEARNING_CURVE_CARD_SUCCESS' as const,
  GetLearningCurveCardFailure: 'GET_LEARNING_CURVE_CARD_FAILURE' as const,
  GetViewLearningCurveModal: 'GET_VIEW_LEARNING_CURVE_CARD_MODAL' as const,
  GetViewLearningCurveModalSuccess: 'GET_VIEW_LEARNING_CURVE_MODAL_SUCCESS' as const,
  GetViewLearningCurveModalFailure: 'GET_VIEW_LEARNING_CURVE_MODAL_FAILURE' as const,
  SetShowAllLearningCurvesLoader: 'SET_ALL_LEARNING_CURVES' as const,
  GetAllLearningCurves: 'GET_ALL_LEARNING_CURVES' as const,
  GetAllLearningCurvesSuccess: 'GET_ALL_LEARNING_CURVES_SUCCESS' as const,
  GetAllLearningCurvesFailure: 'GET_ALL_LEARNING_CURVES_FAILURE' as const,
  EditLearningCurveOrderEfficiency: 'EDIT_LEARNING_CURVE_ORDER_EFFICIENCY' as const,
  EditLearningCurveOrderEfficiencySuccess: 'EDIT_LEARNING_CURVE_ORDER_EFFICIENCY_SUCCESS' as const,
  EditLearningCurveOrderEfficiencyFailure: 'EDIT_LEARNING_CURVE_ORDER_EFFICIENCY_FAILURE' as const,
  SetPoDetailsLoader: 'SET_PO_DETAILS_LOADER' as const,
  SetProcessMappingDetailsLoader: 'SET_PROCESS_MAPPING_DETAILS_LOADER' as const,
  ClearPoCardDetails: 'CLEAR_PO_CARD_DETAILS' as const,
  GetPoDetailsCard: 'GET_PO_DETAILS_CARD' as const,
  GetPoDetailsCardSuccess: 'GET_PO_DETAILS_CARD_SUCCESS' as const,
  GetPoDetailsCardFailure: 'GET_PO_DETAILS_CARD_FAILURE' as const,
  FetchProcessMappingDetailsCard: 'FETCH_PROCESS_MAPPING_DETAILS_CARD' as const,
  FetchProcessMappingDetailsCardSuccess: 'FETCH_PROCESS_MAPPING_DETAILS_CARD_SUCCESS' as const,
  FetchProcessMappingDetailsCardFailure: 'FETCH_PROCESS_MAPPING_DETAILS_CARD_FAILURE' as const,
  AddUpdatePoDetailsOrder: 'ADD_UPDATE_PO_DETAILS_ORDER' as const,
  AddUpdatePoDetailsOrderSuccess: 'ADD_UPDATE_PO_DETAILS_ORDER_SUCCESS' as const,
  AddUpdatePoDetailsOrderFailure: 'ADD_UPDATE_PO_DETAILS_ORDER_FAILURE' as const,
  DeletePoDetailsOrder: 'DELETE_PO_DETAILS_ORDER' as const,
  DeletePoDetailsOrderSuccess: 'DELETE_PO_DETAILS_ORDER_SUCCESS' as const,
  DeletePoDetailsOrderFailure: 'DELETE_PO_DETAILS_ORDER_FAILURE' as const,
  GetPoColorSizeQtyDetails: 'GET_PO_COLOR_SIZE_QTY_DETAILS' as const,
  GetPoColorSizeQtyDetailsuccess: 'GET_PO_COLOR_SIZE_QTY_DETAILS_SUCCESS' as const,
  GetPoColorSizeQtyDetailsFailure: 'GET_PO_COLOR_SIZE_QTY_DETAILS_FAILURE' as const,
  UpdatePoColorQtyByRatio: 'UPDATE_PO_COLOR_QTY_BY_RATIO' as const,
  UpdatePoColorQtyByRatioSuccess: 'UPDATE_PO_COLOR_QTY_BY_RATIO_SUCCESS' as const,
  UpdatePoColorQtyByRatioFailure: 'UPDATE_PO_COLOR_QTY_BY_RATIO_FAILURE' as const,
  UpdatePoColorSizeQtyManually: 'UPDATE_PO_COLOR_SIZE_QTY_MANUALLY' as const,
  UpdatePoColorSizeQtyManuallySuccess: 'UPDATE_PO_COLOR_SIZE_QTY_MANUALLY_SUCCESS' as const,
  UpdatePoColorSizeQtyManuallyFailure: 'UPDATE_PO_COLOR_SIZE_QTY_MANUALLY_FAILURE' as const,
  SetOrderAllocationLoader: 'SET_ORDER_ALLOCATION_LOADER' as const,
  ClearAllocationCardDetails: 'CLEAR_ALLOCATION_CARD_DETAILS' as const,
  GetAllocationCardDetails: 'GET_ALLOCATION_CARD_DETAILS' as const,
  GetAllocationCardDetailsuccess: 'GET_ALLOCATION_CARD_DETAILS_SUCCESS' as const,
  GetAllocationCardDetailsFailure: 'GET_ALLOCATION_CARD_DETAILS_FAILURE' as const,

  SetOrderTimelineLoader: 'SET_ORDER_TIMELINE_LOADER' as const,
  GetOrderTimelineCardDetails: 'GET_ORDER_TIMELINE_CARD_DETAILS' as const,
  GetOrderTimelineCardDetailsSuccess: 'GET_ORDER_TIMELINE_CARD_DETAILS_SUCCESS' as const,
  GetOrderTimelineCardDetailsFailure: 'GET_ORDER_TIMELINE_CARD_DETAILS_FAILURE' as const,
  SetLinewisePlannedQtyLoader: 'SET_LINEWISE_PLANNED_QTY_LOADER' as const,
  GetLinewisePlannedQtyCardDetails: 'GET_LINEWISE_PLANNED_QTY_CARD_DETAILS' as const,
  GetLinewisePlannedQtyCardDetailsSuccess: 'GET_LINEWISE_PLANNED_QTY_CARD_DETAILS_SUCCESS' as const,
  GetLinewisePlannedQtyCardDetailsFailure: 'GET_LINEWISE_PLANNED_QTY_CARD_DETAILS_FAILURE' as const,

  SetOperationBreakdownDetailsLoader: 'SET_OPERATION_BREAKDOWN_DETAILS_LOADER' as const,
  GetOperationBreakdownDetails: 'GET_OPERATION_BREAKDOWN_DETAILS' as const,
  GetOperationBreakdownDetailsSuccess: 'GET_OPERATION_BREAKDOWN_DETAILS_SUCCESS' as const,
  GetOperationBreakdownDetailsFailure: 'GET_OPERATION_BREAKDOWN_DETAILS_FAILURE' as const,
};
